import { render, staticRenderFns } from "./DeadPage.vue?vue&type=template&id=f2d55bda&scoped=true&"
import script from "./DeadPage.vue?vue&type=script&lang=js&"
export * from "./DeadPage.vue?vue&type=script&lang=js&"
import style0 from "./DeadPage.vue?vue&type=style&index=0&id=f2d55bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d55bda",
  null
  
)

export default component.exports